import styled from 'styled-components';

export default styled.div`
  background-color: ${(props) => props.theme.colors.black};
  .pagination--wrapper {
    display: none;
  }
`;
